import axios from "axios";
import Config from "../utils/Config";

const BASE_URL = Config.apiUrl;

class AgentCustomerEvents {
  getAuthHeaders() {
    const token = localStorage.getItem("trp_agt_tk") || "";
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  }

  /**
   * Fetch all customer event purchases for the logged-in agent.
   * GET https://api.tripsecuregh.com/api/agent/get/all/customer_event
   */
  async getAllCustomerEvents() {
    try {
      const response = await axios.get(
        `${BASE_URL}/agent/get/all/customer_event`,
        this.getAuthHeaders()
      );
      // API shape: { data: { status_code, message, reason, data: [...], point_in_time } }
      const inner = response.data?.data ?? response.data;
      const list = Array.isArray(inner?.data)
        ? inner.data
        : Array.isArray(inner?.customer_events)
        ? inner.customer_events
        : Array.isArray(inner)
        ? inner
        : [];
      const ok = inner?.status_code === 200 || response.status === 200;
      return {
        status: !!ok,
        data: inner,
        list,
        message: inner?.message ?? inner?.reason ?? "Customer events fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        list: [],
        message:
          error.response?.data?.message ??
          error.response?.data?.reason ??
          "An error occurred while fetching customer events",
      };
    }
  }
}

const agentCustomerEventsService = new AgentCustomerEvents();
export default agentCustomerEventsService;
